export function componentsJSToRgbaString(components: number[]): string {
    return (
        'rgba(' +
        components[0] +
        ',' +
        components[1] +
        ',' +
        components[2] +
        ',' +
        components[3] +
        ')'
    );
}

export function int2rgb(hex: number): number[] {
    const rgb = [];
    rgb.push((hex >> 16) & 0xff);
    rgb.push((hex >> 8) & 0xff);
    rgb.push(hex & 0xff);

    return rgb;
}

export function prefersReducedMotion() {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!mediaQuery || mediaQuery.matches) {
        return true;
    }
    return false;
}
